import { useEffect, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../context/AuthContext'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import WelcomeBanner from './components/WelcomeBanner'
import MembershipStatus from './components/MembershipStatus'
import NextMatch from './components/NextMatch'
import WelfarePreview from './components/WelfarePreview'
import ChapterLeads from './components/ChapterLeads'

export default function Dashboard() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [supporter, setSupporter] = useState(null)
  const [isPaid, setIsPaid] = useState(false)

  useEffect(() => {
    if (!user) { navigate('/login'); return }
    const fetchData = async () => {
      const { data } = await supabase
        .from('supporters')
        .select('*, chapters(name), clubs(name)')
        .eq('id', user.id)
        .single()
      if (data) setSupporter(data)

      const { data: sub } = await supabase
        .from('subscriptions').select('valid_until')
        .eq('supporter_id', user.id)
        .order('valid_until', { ascending: false })
        .limit(1).single()
      if (sub && new Date(sub.valid_until) >= new Date()) setIsPaid(true)
    }
    fetchData()
  }, [user, navigate])

  return (
    <div className="relative min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col overflow-hidden">

      {/* Watermark */}
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-contain opacity-[0.08] dark:opacity-[0.06] pointer-events-none"
        style={{ backgroundImage: "url('/images/dsms_watermark.png')" }}
      />

      <Navbar />
      <div className="relative z-10 flex-1 px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-10 max-w-6xl mx-auto w-full pb-24 sm:pb-6">
        <WelcomeBanner supporter={supporter} />
        <MembershipStatus supporter={supporter} isPaid={isPaid} />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 mt-4 lg:mt-6">
          <NextMatch />
          <WelfarePreview isPaid={isPaid} />
          <ChapterLeads supporter={supporter} />
        </div>
      </div>

      {/* Sticky bottom CTA for unpaid — mobile only */}
      {!isPaid && (
        <div className="sm:hidden fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-black border-t border-gray-200 dark:border-white/10 px-4 py-3">
          <Link
            to="/subscribe"
            className="block w-full bg-green-600 hover:bg-green-700 text-white py-3 font-bold uppercase tracking-widest text-sm transition-colors text-center"
          >
            Activate Membership
          </Link>
        </div>
      )}

      <Footer />
    </div>
  )
}